import Emoji from 'react-emoji-render';

const TextRenderer = (text: string) => <Emoji text={text} />;

export default TextRenderer;
